import { render, staticRenderFns } from "./success.vue?vue&type=template&id=b2e59a98&scoped=true&"
var script = {}
import style0 from "./success.vue?vue&type=style&index=0&id=b2e59a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e59a98",
  null
  
)

export default component.exports